import { render, staticRenderFns } from "./Wp_hm_config.vue?vue&type=template&id=455050d2&scoped=true&"
import script from "./Wp_hm_config.vue?vue&type=script&lang=js&"
export * from "./Wp_hm_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455050d2",
  null
  
)

export default component.exports